<div class="page-setting">
  <sh-grid fit-content="true">
    <div class="default-profile-img" columns="12">
      <div class="profile-grid">
        <sh-grid>
          <div class="userProfileSection" columns="1" col-s="12" col-m="12">
            <img class="profile-img" title="Please make image dimention of 360 x 360 for better appearance"
              [src]="userProfileImageURL">
            <ngx-file-drop id="dropFilesBox" class="dropFile" headertext="Drop files here">
              <!-- <span>optional content (don't set headertext then)</span> -->
            </ngx-file-drop>
            <div class="org-name">
              <sh-text size='title-2' color="primary" *ngIf="targetUser">Siemens Healthineers</sh-text>
              <br>
              <sh-text size='super-header' color="primary" *ngIf="targetUser">{{targetUser.name}}</sh-text>
              <sh-text size='body-2' color="primary" *ngIf="targetUser">{{targetUser.userEmailId}}</sh-text>
              <sh-button id="browseBtn1" label="Browse" *ngIf="isProfileImageEdit" color="Primary"
                (click)="Image.click()" class="browse">
              </sh-button>
              <sh-button class="browse" id="deleteButton" label="Delete" *ngIf="isProfileImageDelete" color="secondary" shape="pill-s"

                onclick="document.querySelector('#deleteProfileModal').visible = true"></sh-button>
              <input type="file" id="userImage" hidden #Image accept="image/*"
                (change)="handleProfileImageInput($event.target.files)" name="Image">
              <sh-button class="upload-btn" label="Upload" color="Primary" *ngIf="isProfileImageEdit"
                (click)="uploadUserProfileImage(Image)" [disabled]="isDisableUploadButton"></sh-button>
            </div>
            <sh-icon class="edit-delete-icon" id="editUserProfileIcon" [disabled]="currentUserCheck()" icon="edit"
             (click)="enableEditProfileImage()">
            </sh-icon>
            <sh-icon class="edit-delete-icon" id="deleteUserProfileIcon" [disabled]="currentUserCheck()" icon="delete"
              (click)="enableDeleteProfileImage()">
            </sh-icon>
          </div>
        </sh-grid>
        <!-- <div class="userProfileSection" col-s="12" col-m="12">
         <div col-s="6" col-m="6">
           <img src="assets/img/userDefault.png">
         </div>
         <div>
           
         </div>
        </div> -->

      </div>



    </div>

    <div class="nav-bar-setting" columns="12">
      <sh-nav-bar slot='nav'>
        <sh-tabs>
          <sh-tab-item id="admiredTab" label="Summary" (click)="onTabClick('admired')" active
            [disabled]="admiredTabFlgDisable"></sh-tab-item>
          <sh-tab-item id="allModelTab" label="All Models" (click)="onTabClick('all')" [disabled]="allModelTabDisable">
          </sh-tab-item>
          <!-- <sh-tab-item label="Subscribed" (click)="onTabClick('subscribed')"></sh-tab-item>
          <sh-tab-item label="Likes" (click)="onTabClick('likes')" disabled></sh-tab-item> -->
        </sh-tabs>
      </sh-nav-bar>

    </div>
  </sh-grid>



  <div class="admired-model-div">
    <sh-text class="admired-model-text" *ngIf="selectedTab==='admired'" size="title-1">Admired Models
    </sh-text>
    <sh-grid>

      <div columns="8" col-s="12" col-m="6">
        <div *ngIf="assetsCardDetails.length>0">
          <sh-grid>
            <div columns="12">
              <sh-grid>

                <div class="cursor-pointer" columns="4" col-m="4" col-s="12" *ngFor="let asset of assetsCardDetails"
                  id="assetCard">
                  <app-asset-card [asset]="asset"></app-asset-card>
                </div>
              </sh-grid>
            </div>
          </sh-grid>
        </div>
        <div *ngIf="spinnerFlg">
          <sh-spinner label="Loading" overlay=false></sh-spinner>
        </div>
        <div *ngIf="assetsCardDetails.length==0 && spinnerFlg==false">
          <sh-empty-state icon="error" label="No assets were found.">
          </sh-empty-state>
        </div>

      </div>
      <div columns="4" col-s="12" col-m="6">
        <sh-pane slot='right'>
          <sh-accordion label="About" expanded>
            <sh-text id="aboutUserTxt" *ngIf="aboutUser.length>0 && !editClickedFlg;else aboutUserTextArea"
              size="title-1">{{aboutUser}}</sh-text>
            <sh-icon id="editIcon" *ngIf="selfProfileFlg && aboutUser.length>0 && editClickedFlg==false" icon="edit"
              (click)="editClickedFlg=true;">
            </sh-icon>

            <!-- <sh-input-text *ngIf="aboutUserUpdateFlag" id="aboutUserEditTextArea" [value]="aboutUser" textarea=true (value-changed)="aboutUserEditedTxt=$event.target.value"></sh-input-text>
            <sh-button *ngIf="aboutUserUpdateFlag" id="updateAbtUserEditBtn" label="Edit" color="Primary" style="float:right;margin-top:3px;" (click)="updateUsersAbout(aboutUserEditedTxt)" [disabled]="aboutUserTxt.length==0"></sh-button> -->


            <!-- <sh-button *ngIf="selfProfileFlg" label="Edit" id="editAbtUserBtn" (click)="updateUsersAbout(aboutUserTxt)"></sh-button> -->
            <ng-template #aboutUserTextArea>
              <div *ngIf="selfProfileFlg;else otherUserAboutErr">
                <sh-input-text id="aboutUserTextArea" [value]="aboutUser!=null?aboutUser:''" textarea=true
                  label="Say something about you" (value-changed)="aboutUserTxt=$event.target.value"></sh-input-text>
                <sh-button id="updateAbtUserBtn" label="Update" color="Primary"
                  (click)="updateUsersAbout(aboutUserTxt)" [disabled]="aboutUserTxt.length==0"></sh-button>
              </div>
              <ng-template #otherUserAboutErr>
                <sh-text id="otherUserAboutTxt" size="title-1">User has not added his
                  details</sh-text>
              </ng-template>
            </ng-template>
          </sh-accordion>


          <sh-accordion label="Skills" expanded>
            <sh-text class="skills-text" *ngIf="skillsArray[0].length>0 && !editSkillClickedFlg;else skillsNotFound" size="title-1">{{skillsArray[0]}}</sh-text>

            <sh-icon id="editSkillIcon" *ngIf="selfProfileFlg && skillsArray[0].length>0 && editSkillClickedFlg==false"
              icon="edit"
              (click)="editSkillClickedFlg=true"></sh-icon>

            <ng-template #skillsNotFound>
              <div *ngIf="selfProfileFlg;else otherUserSkillErr">
                <!-- <sh-text id="skill">{{skillArrayConcatText}}</sh-text>
         <sh-input-text id="addSkillTxt" label="Add a skill" (keyup.enter)="addSkill($event.target.value.trim());$event.target.value = ''"></sh-input-text>
         <sh-button id="saveSkillBtn" label="Update" color="Primary" style="float:right;margin-top:3px;" (click)="saveSkills()" [disabled]="skillArrayConcatText.length==0"></sh-button> -->

                <sh-input-text id="addSkillTxt" [value]="skillsArray[0].length>0?skillsArray[0]:''" textarea=true
                  label="Add your skills" (value-changed)="userSkillText=$event.target.value"></sh-input-text>
                <sh-button id="updateSkillBtn" label="Update" color="Primary"
                  (click)="saveSkills(userSkillText)" [disabled]="userSkillText.length==0"></sh-button>


              </div>
              <ng-template #otherUserSkillErr>
                <sh-text id="otherUserSkillTxt" size="title-1">User has not added any skill
                </sh-text>
              </ng-template>


              <!-- <sh-button id="addSkillBtn" label="Add" color="Primary" style="float:left;" (click)="addSkill(skillInputText)"></sh-button> -->

            </ng-template>
          </sh-accordion>

        </sh-pane>
      </div>

    </sh-grid>
  </div>
  <sh-modal class="set-z-index" id="deleteProfileModal" type='alert' label='Warning' modal-height='184px' modal-width='450px'>
    <sh-text class="delete-profile-modal" size='title-1' size="title-1" color="primary">Do you want to delete user profile
      image?</sh-text>

    <sh-button slot="footer" color="secondary" label="No"
      onclick="document.querySelector('#deleteProfileModal').visible = false"></sh-button>
    <sh-button slot="footer" label="Yes" (click)="deleteUserProfileImage()"
      onclick="document.querySelector('#deleteProfileModal').visible = false"></sh-button>
  </sh-modal>
  <sh-notifications class="notification-card">
    <sh-notification-item type="confirmation" label="Success" id="success" [visible]="isShowNotificationSuccess">
      {{showSuccessMessage}}
    </sh-notification-item>
    <sh-notification-item type="error" label="Error" id="failure" [visible]="isShowNotificationFailure">
      {{showFailureMessage}}
    </sh-notification-item>
    <sh-notification-item type="alert" label="Alert" id="alert" [visible]="isShowNotificationAlert">
      {{showAlertMessage}}
    </sh-notification-item>
  </sh-notifications>
</div>